import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { cancelRemoteAction } from '../actions/remoteactions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'

import RemoteActionStatusBadge from './RemoteActionStatusBadge'
import LoadingProgress from './LoadingProgress'

class RemoteActionsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deleting: false,
      deleteConfirmShown: false,
      deleteId: null,
      action: null,
      resultShown: false,
      copied: false
    }

    this.resultToggle = this.resultToggle.bind(this)
    this.resultShow = this.resultShow.bind(this)
    this.copyResult = this.copyResult.bind(this)
    this.delete = this.delete.bind(this)
    this.deleteConfirmShow = this.deleteConfirmShow.bind(this)
    this.deleteConfirmToggle = this.deleteConfirmToggle.bind(this)
  }

  // Normalize the raw result string for display: detect/pretty-print JSON,
  // flag the empty case so the modal can show a friendly placeholder.
  formatResult(result) {
    if (result === null || result === undefined || String(result).trim() === '') {
      return { text: '', isJson: false, empty: true }
    }

    const text = typeof result === 'string' ? result : String(result)
    const trimmed = text.trim()

    if ((trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
      try {
        return { text: JSON.stringify(JSON.parse(trimmed), null, 2), isJson: true, empty: false }
      } catch (e) {
        // not valid JSON, fall through to plain text
      }
    }

    return { text, isJson: false, empty: false }
  }

  copyResult() {
    const action = this.state.action || {}
    const { text } = this.formatResult(action.result)
    if (!text || !navigator.clipboard || !navigator.clipboard.writeText) {
      return
    }

    navigator.clipboard.writeText(text)
      .then(() => {
        this.setState({ copied: true })
        setTimeout(() => this.setState({ copied: false }), 1500)
      })
      .catch(() => {})
  }

  delete() {
    const { cancelRemoteAction } = this.props

    this.setState({ deleting: true, deleteConfirmShown: false })
    cancelRemoteAction(this.state.deleteId)
  }

  deleteConfirmShow(id) {
    this.setState({
      deleteConfirmShown: true,
      deleteId: id
    })
  }

  deleteConfirmToggle() {
    this.setState({ deleteConfirmShown: !this.state.deleteConfirmShown })
  }

  resultToggle() {
    this.setState({ resultShown: !this.state.resultShown })
  }

  resultShow(action, e) {
    this.setState({ action: action, resultShown: true, copied: false })
  }

  render() {

    const { remoteActions } = this.props;

    if (remoteActions.loading) {
      return <LoadingProgress />;
    }

    if (remoteActions.error) {
      return (<h2>Error al cargar las acciones remotas</h2>);
    }

    // Ensure remoteActions is an array before mapping
    const actionsList = Array.isArray(remoteActions.remoteActions) ? remoteActions.remoteActions : [];


    return (
      <div className="mt-5 remote-actions-list">
        <div className="table-responsive" style={{overflowX: 'auto', WebkitOverflowScrolling: 'touch'}}>
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Fecha/Hora</th>
                <th scope="col">Código</th>
                <th scope="col">Argumentos</th>
                <th scope="col">Estado</th>
                <th scope="col">Ejecutor</th>
                <th scope="col">Resultado</th>
                <th scope="col">Cancelar</th>
              </tr>
            </thead>
            <tbody>
              {actionsList.map(remoteAction => (
                <tr key={remoteAction._id}>
                  <td>
                    {(new Date(remoteAction.date)).toLocaleString()}
                  </td>
                  <td>{remoteAction.code}</td>
                  <td>
                    <tt>{remoteAction.arguments}</tt>
                  </td>
                  <td>
                    <RemoteActionStatusBadge status={remoteAction.status} />
                  </td>
                  <td>{remoteAction.executor}</td>
                  <td>
                    <button className="btn ra-eye-btn"
                      onClick={e => this.resultShow(remoteAction, e)}>
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                  <td>
                    <button className="btn ra-cancel-btn"
                      disabled={remoteAction.status === 'COMPLETE' || remoteAction.status === 'CANCELED' || remoteAction.status === 'ERROR'}
                      onClick={() => this.deleteConfirmShow(remoteAction._id)}>
                      <i className="fas fa-cross"></i>
                    </button>
                  </td>
                </tr>
              )
              )}
            </tbody>
          </table>
        </div>
        {(() => {
          const action = this.state.action || {}
          const { text, isJson, empty } = this.formatResult(action.result)
          const args = (action.arguments && String(action.arguments).trim()) ? action.arguments : '—'
          return (
            <Modal isOpen={this.state.resultShown} toggle={this.resultToggle}
              size="lg" centered className="ra-result-modal">
              <ModalHeader toggle={this.resultToggle}>
                <i className="fas fa-terminal mr-2"></i>
                Resumen de la acción
              </ModalHeader>
              <ModalBody>
                {/* What was sent */}
                <div className="ra-section ra-section--sent">
                  <div className="ra-section-label">
                    <i className="fas fa-paper-plane"></i>
                    <span>Enviado</span>
                  </div>
                  <div className="ra-kv-grid">
                    <div className="ra-kv">
                      <span className="ra-kv-key">Código</span>
                      <span className="ra-kv-val">
                        <span className="ra-chip">{action.code || '—'}</span>
                      </span>
                    </div>
                    <div className="ra-kv">
                      <span className="ra-kv-key">Fecha / Hora</span>
                      <span className="ra-kv-val">
                        {action.date ? (new Date(action.date)).toLocaleString() : '—'}
                      </span>
                    </div>
                    <div className="ra-kv">
                      <span className="ra-kv-key">Ejecutor</span>
                      <span className="ra-kv-val">{action.executor || '—'}</span>
                    </div>
                    <div className="ra-kv ra-kv--full">
                      <span className="ra-kv-key">Argumentos</span>
                      <span className="ra-kv-val ra-kv-val--mono">{args}</span>
                    </div>
                  </div>
                </div>

                {/* What was received */}
                <div className="ra-section ra-section--received">
                  <div className="ra-section-label">
                    <i className="fas fa-inbox"></i>
                    <span>Recibido</span>
                    {action.status &&
                      <span className="ra-section-status">
                        <RemoteActionStatusBadge status={action.status} />
                      </span>
                    }
                  </div>
                  {empty ? (
                    <div className="ra-result-empty">
                      <i className="fas fa-hourglass-half"></i>
                      <span>Sin resultado disponible</span>
                    </div>
                  ) : (
                    <div className="ra-result-console">
                      <div className="ra-result-console-bar">
                        <span className="ra-dot ra-dot-red"></span>
                        <span className="ra-dot ra-dot-yellow"></span>
                        <span className="ra-dot ra-dot-green"></span>
                        <span className="ra-result-console-title">
                          {isJson ? 'JSON' : 'output'}
                        </span>
                      </div>
                      <pre className="ra-result-pre">{text}</pre>
                    </div>
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="link" className="ra-result-copy"
                  disabled={empty} onClick={this.copyResult}>
                  <i className={`fas ${this.state.copied ? 'fa-check' : 'fa-copy'} mr-1`}></i>
                  {this.state.copied ? 'Copiado' : 'Copiar resultado'}
                </Button>
                <Button color="primary" onClick={this.resultToggle}>Cerrar</Button>
              </ModalFooter>
            </Modal>
          )
        })()}
        {/* Confirm deletion */}
        <div>
          <Modal isOpen={this.state.deleteConfirmShown}
            toggle={this.deleteConfirmToggle}>
            <ModalHeader toggle={this.deleteConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de cancelar la acción remota?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.delete}>
                Si
              </Button>
              <Button color="secondary" onClick={this.deleteConfirmToggle}>
                No
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  remoteActions: state.remoteactions
})

const mapDispatchToProps = dispatch => ({
  cancelRemoteAction: bindActionCreators(cancelRemoteAction, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionsList)

